import React from "react"

const ButtonLink = ({ link, action, className, title, isEdit = false }) => {
  return (
    <a
      style={
        action
          ? { opacity: 1, backgroundColor: isEdit ? "#1B467F" : undefined }
          : { opacity: 0, display: "none" }
      }
      href={link}
      target="_blank"
      className={className}
    >
      {title}
    </a>
  )
}

export default ButtonLink
